export const CONTACT_PHONE = '+48 662 963 438';
export const CONTACT_PHONE_HREF = `tel:${CONTACT_PHONE.replace(/\s/g, '')}`;

export const CONTACT_EMAIL = 'ruslan@mavinx.com';
export const CONTACT_EMAIL_HREF = `mailto:${CONTACT_EMAIL}`;
